// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShopperGroupIncentiveIcon_icon__2kL8g"};